export default "__VITE_ASSET__dKYS7clK__"